import { create } from "../../../../../common/utils/zustand_state_manager";
import { TreinamentoDropDown } from "../../../domain/models/treinamento_dropdown";
import { FuncionarioAssinaturaDropDown } from "../../../domain/models/funcionario_assinatura_dropdown";

/**
 * useGestaoTreinamentosCadastroFilters
 */

type State = {
  treinamentoLista: TreinamentoDropDown[] | null,
  funcionarioAssinaturas: FuncionarioAssinaturaDropDown[] | null,
};

export const useGestaoTreinamentosCadastroFilters = create<State>((set) => ({
  treinamentoLista: null,
  funcionarioAssinaturas: null,
}));